import { Pipe, PipeTransform } from '@angular/core';
import { BankService } from '../service/bank.service';

@Pipe({
  name: 'bankName'
})
export class BankNamePipe implements PipeTransform {
  constructor(private bankService: BankService) {}

  transform(id: string, type: 'IBAN' | 'CARD') {
    if (type === 'CARD') {
      return this.bankService.getBankNameFromCard(id);
    } else {
      return this.bankService.getBankNameFromIban(id);
    }
  }
}
